const promisify = (f) => (...args) => new Promise((res, rej) => {
    const callback = (response) => {
        if (!!response && typeof response === 'object' && (('status' in response && response.status !== 'ERROR') || !('status' in response))) {
            res(response);
            return;
        }
        rej(response);
    };
    f(...args, callback);
});

export { promisify };
